<form [formGroup]="form" (ngSubmit)="submit()">
  <h1 mat-dialog-title translate="audience/export"></h1>
  <mat-dialog-content>
    <p translate="audience/export/description"></p>
    <app-select
      *ngIf="customFields.length"
      appearance="outline"
      [labelKey]="'audience/export/select-custom-fields'"
      [control]="form.get('customFields')"
      [items]="customFields"
      [multiple]="true">
    </app-select>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button type="submit" color="primary" translate="audience/export/submit"></button>
    <button mat-raised-button type="button" (click)="dialogRef.close()" translate="cancel"></button>
  </mat-dialog-actions>
</form>
